<h5 class="download-head">Select the opportunity model(s) you want to include in your download:</h5>
<div class="row">
  <div class="col-md-12 col-sm-12 col-12 my-3">
    <mat-form-field class="w-100">
      <mat-label>Report Model</mat-label>
      <mat-select [formControl]="report" multiple>
        <mat-select-trigger>{{ selectedReportLabel }} </mat-select-trigger>
        <mat-option
          *ngFor="let report of reportModel"
          (click)="toggleOne(allSelected.viewValue)"
          [value]="report.value"
          >{{ report.label }}</mat-option
        >
        <mat-option #allSelected (click)="toggleAllSelection()" [value]="0">All</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div class="row">
  <div class="col-md-12 col-12 d-flex justify-content-end">
    <button mat-button (click)="proceedCancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="proceed()" [disabled]="isButtonDisabled">Proceed</button>
  </div>
</div>
